<template>
    <div id="app" class="wrapper">
        <div class="login">
            <ValidationObserver ref="observer" v-slot="{ invalid }" class="login__inner" tag="div">
                <div>
                    <img src="@/assets/images/logo.png" v-bind="logoAttrs">
                </div>
                <ValidationProvider name="ID" rules="required" tag="div">
                    <input v-model="input.id" type="text" placeholder="ID">
                </ValidationProvider>
                <ValidationProvider name="password" rules="required" tag="div">
                    <input v-model="input.password" type="password" placeholder="password">
                </ValidationProvider>
                <Loader :loader="loader" />
                <div v-if="!loader">
                    <button :class="X_validatedButtonStyle" type="button" :disabled="$_setValidatedDisabled(invalid)" @click="handleLogIn()">ログイン</button>
                </div>
                <div>
                    <button type="button" @click="$_modalOpen('sendEmailPassword')">パスワードをメールで送る</button>
                </div>
            </ValidationObserver>
        </div>
        <Modal :modal="modal" @action="modalAction($event)" @close="$_modalClose()" />
    </div>
</template>

<script>
    "use strict";

    import Loader from "@/components/OfficesLoader.vue";
    import common from "@/mixins/common";

    export default {
        "components": {
            Loader,
        },
        "mixins": [
            common,
        ],
        data() {
            return {
                "input": {
                    "id": "",
                    "password": "",
                },
                "loader": false,
                "logoAttrs": {
                    "alt": "管クリ",
                    "title": "管クリ",
                },
            };
        },
        "methods": {
            modalAction(key) {
                if (key === "sendEmailPassword") {
                    this.handleSendEmail();
                } else if (key === "sendEmailPassword--finished") {
                    this.$_modalClose();
                }
            },
            handleLogIn() {
                this.loader = true;
                // ログイン
                common.$_axios.post(
                    `${common.$_configs.apiUrl}/offices/login`,
                    this.input
                ).then(response => {
                    localStorage.setItem("token", response.data.access_token);
                    localStorage.setItem("expired", response.data.expired_at);
                    localStorage.setItem("role", response.data.role);
                    this.$router.push({ "name": "offices_delivery_destinations_create" });
                }).catch(() => {
                    this.$_modalError("loginError");
                    this.loader = false;
                });
            },
            handleSendEmail() {
                // 本部IDパスワードをメールで送信
                common.$_axios.post(
                    `${common.$_configs.apiUrl}/offices/login_mail`,
                    {}
                ).then(() => {
                    this.$_modalFinished();
                }).catch(() => {
                    this.$_modalError();
                });
            },
        },
    };
</script>
